export function loadJs(srcUrl: string) {
  const scriptEl = window.document.createElement('script');
  scriptEl.src = srcUrl;
  const head = document.getElementsByTagName('head')[0];
  head.insertBefore(scriptEl, head.firstChild);
}
